import { PropsWithChildren } from 'react';

import { IndeterminateCheckboxProps, IndeterminateCheckbox } from './IndeterminateCheckbox';

export type CheckboxWithLabelProps = PropsWithChildren<IndeterminateCheckboxProps>;

export function CheckboxWithLabel(props: CheckboxWithLabelProps) {
  const { children, disabled, ...rest } = props;
  return (
    <label
      className={`inline-flex cursor-pointer select-none items-center gap-4 ${disabled ? 'cursor-not-allowed opacity-50' : ''}`}
    >
      <IndeterminateCheckbox disabled={disabled} {...rest} />
      {children}
    </label>
  );
}
